import styled from 'styled-components';
import { media } from 'common/responsive';

const FullWidthImage = styled.div`
  width: 100%;
  background-image: url(${({ url }) => url});
  background-size: cover;
  background-position: center center;
  position: absolute;
  right: 0;

  ${media.desktop`
    height: 600px;
  `};
`;

export default FullWidthImage;



// WEBPACK FOOTER //
// ./src/pages/Blog/LatestArticle/FullWidthImage.jsx